<ng-container *transloco="let t;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="deleteDataDialogLabel">{{
                    t("patientprofile.personaldata.dialogtitle")}}</h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="resetInputs()"></button>
            </div>
            <div class="modal-body">
                <div class="card-text" [innerHTML]="cmsEntries['entry1']?.text"></div>
                <p>{{ t("patientprofile.personaldata.confirmdeletetext") }}</p>
                <form [formGroup]="withdrawConsentForm">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="withdrawConsentGroupText" for="cprNumber">
                            {{t("patientprofile.personaldata.cprlabel") }}
                        </span>
                        <input id="cprNumber" formControlName="cprNumber" type="text" class="form-control"
                            aria-label="userId" required>
                    </div>
                </form>
                <p *ngIf="hasError" class="fst-italic text-danger">{{ t(errorText)}}</p>
            </div>
            <div class="modal-footer">
                <ng-container *ngIf="!isLoading; else loadingState">
                    <button *ngIf="userHasConsent === true" class="btn btn-warning" type="submit" (click)="onConfirm()">
                        {{ t("patientprofile.personaldata.deletedata")}}
                        <svg class="icon icon-sm">
                            <use xlink:href="assets/icons.svg#icon-delete"></use>
                        </svg>
                    </button>
                    <button class="btn wp-btn" data-bs-dismiss="modal" (click)="resetInputs()">
                        {{ t("patientprofile.personaldata.deny") }}
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <ng-template #loadingState>
        <loading-spinner-border size="md"></loading-spinner-border>
    </ng-template>
</ng-container>